/* eslint-disable max-lines */
const ja = {
  nav: {
    home: "ホーム",
    drops: "ドロップ",
    upcomingDrops: "Collezioneカタログ",
    cinema: "シネマ",
    archive: "保管庫閉鎖",
    activeDrops: "現行ドロップ",
    signIn: "サインイン",
    apply: "保管庫に入る",
    enterCollezione: "保管庫に入る",
    contact: "コンタクト",
    signOut: "サインアウト",
    hiddenCollezione: "隠された保管庫",
    privacy: "プライバシーポリシー",
  },
  hero: {
    overline: "Est. 2026 — 隠された保管庫",
    headline1: "Garage Drops.",
    headline2: "物語を買う者へ、商品ではなく。",
    subtitle:
      "映画的なオブジェクト、伝説のレストモッド、希少なコレクター車両のプライベートアーカイブ。予告なく公開され、説明なく消える。",
    teaserLabel: "ドロップまで",
    liveBadge: "ドロップ進行中 · メンバー限定",
    nextDropPrefix: "次のドロップ —",
    viewDrops: "ドロップを見る",
    apply: "保管庫に入る",
    scroll: "スクロール",
  },
  countdown: {
    days: "日",
    hours: "時間",
    minutes: "分",
    seconds: "秒",
    live: "ドロップ公開中",
    closes: "ドロップ終了まで",
    imminent: "間もなく · 発表準備中",
  },
  manifesto: {
    overline: "マニフェスト",
    body:
      "私たちはオークションハウスではありません。最高入札者には売りません。希少な一品ずつをリリースし、そして消えます。",
    pillars: [
      { n: "01", t: "選定", d: "すべてのドロップは社内で修復・撮影・記録されます。" },
      { n: "02", t: "ナンバリング", d: "各オブジェクトはシリアル付き証明書を持ちます。複製はありません。" },
      { n: "03", t: "秘匿", d: "メンバー限定の詳細は登録後にのみ表示されます。" },
    ],
  },
  teaser: {
    overline: "近日公開",
    headline: "希少な何かが準備されています。",
    body:
      "次のドロップは保管庫に封印されています。誰よりも先にアナウンスを受け取るには、メンバーシップに申し込んでください。",
    apply: "アーリーアクセスに申し込む",
    signIn: "サインイン",
  },
  cinema: {
    overline: "シネマ · Garage Drops",
    headline: "動き出す保管庫。",
    body:
      "キュレーションされた映像断片：舞台裏、レストア、シネマティックなドライブ。予告なく入れ替わります。",
    publicOverline: "公開リール",
    publicTitle: "誰でも観られる映像。",
    exclusiveOverline: "エクスクルーシブ・シネマ",
    exclusiveTitle: "保管庫に入った人だけへ。",
    exclusiveLockedHeadline: "予約された第2のリール。",
    exclusiveLockedBody: "保管庫に入って全てを解放してください。",
    exit: "閉じる",
  },
  contact: {
    overline: "コンタクト · Garage Drops",
    headline: "ご連絡ください。個別に返信します。",
    body: "プライベートな問い合わせ、コラボ、販売・委託について。",
    directOverline: "ダイレクトメール",
    directHeadline: "直接書きたい方は?",
    directBody: "24時間以内に返信します。",
    firstName: "名",
    lastName: "姓",
    email: "Email",
    country: "国",
    message: "メッセージ",
    messagePlaceholder: "情報を希望...",
    submit: "メッセージ送信",
    submitting: "暗号化中…",
    successText: "メッセージを受領しました",
    successSub: "個別にご返信いたします。",
    error: "送信に失敗しました。",
  },
  releases: {
    overline: "現在のリリース",
    headline: "保管庫の中で。",
    allDrops: "すべてのドロップ →",
  },
  membership: {
    overline: "メンバーシップ",
    headline: "扉が開いた者だけが見られるドロップがあります。",
    body:
      "メンバーシップは無料です。国を選び、パスフレーズを設定し、アーカイブを開いてください — すべてのドロップ、すべての物語、すべての写真を。",
    apply: "保管庫に入る",
  },
  drops: {
    overline: "保管庫",
    headline: "現在のドロップ。",
    subtitle:
      "各リリースはここに短い間だけ存在します。カウントダウンが終わると、オブジェクトはプライベートコレクションかアーカイブに移ります。",
    empty: "まだドロップは公開されていません。保管庫はリリースの間です。",
    loading: "読み込み中…",
    membersOnly: "メンバー限定",
    live: "ライブ中",
    unlockingOverline: "保管庫の状態",
    unlockingHeadline: "次の Garage Drop はまもなく解錠",
    unlockingMystery: "扉が開くのは、ふさわしい時刻だけ。",
    showcaseLabel: "保管庫アーカイブ — 名前は明かさず",
  },
  drop: {
    backLink: "ドロップ一覧へ戻る",
    membersOnlyHeadline: "このドロップは内側のサークル限定です。",
    lockedOverline: "ドロップ間近",
    lockedHeadline: "このドロップはまもなく公開されます。",
    lockedBody: "カウントダウンがゼロになった瞬間、詳細がここに表示されます。お近くで — 保管庫はまもなく開きます。",
    backHome: "ホームへ戻る",
    membersOnlyBody:
      "メンバーシップに申し込むと、写真、仕様、物語、プリズムカウントダウンが解放されます。",
    apply: "今すぐ申し込む",
    signIn: "サインイン",
    object: "オブジェクト",
    specs: "仕様",
    gallery: "ギャラリー",
    story: "物語",
    notFound: "ドロップが見つかりません。",
    backToCollezione: "保管庫に戻る",
    teaserOverline: "ドロップ予告",
    teaserHeadline: "今はひとつの手がかりだけ。",
    teaserBody: "完全なドロップは公開時に明かされます。保管庫で待機を — 最初にお知らせします。",
    price: "価格",
    priceOnRequest: "応相談",
    interested: "興味があります",
    inCatalogOverline: "カタログ内",
    inCatalogHeadline: "現在販売しておりません。",
    inCatalogBody:
      "シネマティック・ドロップ・システムを通じて、一度に一台のみが公式に発表されます。この車両は非公開アーカイブに保管されており、シグナルが呼び戻すときに再び姿を現すかもしれません。",
    inCatalogMemberBody:
      "この車両は現在販売されていませんが、プライベートコレクションの一部です。詳細情報をご希望の方は、以下のフォームにご記入ください。",
    inCatalogCta: "メンバーになる",
    categories: {
      esterno: "外観",
      interno: "内装",
      sx: "左側面",
      dx: "右側面",
      sopra: "上面",
      sotto: "下面",
      particolari: "ディテール",
      restauro: "レストア · 写真と動画",
      video: "動画",
    },
  },
  signalPrivileges: {
    overline: "シグナルの特権",
    headline: "保管庫で解放されるもの。",
    body: "シグナルはプライベートな回線です。少数の名前、早期アクセス、公的チャネルを通らない通信。",
    items: [
      "プライベート・ドロップへの早期アクセス",
      "公に出されない車両",
      "ドロップ前の機密通信",
      "Concierge による専属交渉",
      "次回コレクター・ドロップの優先権",
      "保管庫内のフル・シネマティック映像",
      "プライベート・アーカイブへのアクセス",
    ],
    footer: "シグナルは限定的。名前は少数のみ。",
  },
  howItWorks: {
    overline: "仕組み",
    headline: "5つのステップ。ひとつの完全なドロップ。",
    steps: [
      "ドロップはプライベートに準備される。",
      "メンバーが最初にシグナルを受け取る。",
      "車両は限られた時間だけ姿を現す。",
      "交渉は Concierge を通して進む。",
      "ドロップはアーカイブに入り、消える。",
    ],
  },
  archive: {
    overline: "機密 · 閉鎖アーカイブ",
    headline: "保管庫は閉じられました。",
    body: "保管庫を通り抜けて消えた車たち。終わった物語。終了した通信。",
    empty: "閉鎖された通信はまだありません。終わった信号がここに表示されます。",
    statusLabels: {
      ended: "信号終了",
      closed: "通信終了",
      locked: "ドロップロック",
      lost: "信号喪失",
      archived: "アーカイブ済み",
    },
    whispers: [
      "信号は戻るかもしれない。",
      "在庫状況不明。",
      "通信終了。",
      "物語は閉じた。",
      "復帰の確認なし。",
    ],
  },
  auth: {
    loginOverline: "サインイン",
    loginHeadline: "保管庫があなたを認識します。",
    loginBody: "詳細を入力してアーカイブを開いてください。",
    email: "Email",
    passwordLabel: "パスフレーズ",
    submitLogin: "サインイン",
    submittingLogin: "確認中…",
    notMember: "まだメンバーではありませんか?",
    applyLink: "保管庫に入る",

    registerOverline: "申し込み",
    registerHeadline: "アーカイブの中へ。",
    registerBody:
      "メンバーシップは無料で、これからもそうです。どこにいるか教えてください。",
    country: "国",
    firstName: "名",
    lastName: "姓",
    passwordMin: "パスフレーズ(最低6文字)",
    privacyConsent1: "私は",
    privacyConsentLink: "プライバシーポリシー",
    privacyConsent2:
      "を読み、GDPRに基づくデータ処理に同意します。",
    submitRegister: "保管庫を開く",
    submittingRegister: "開いています…",
    alreadyMember: "すでに中にいますか?",
    signInLink: "サインイン",

    welcomeBack: "保管庫へお帰りなさい。",
    welcomeNew: "ようこそ。保管庫が開きました。",
    privacyRequired: "プライバシーポリシーに同意する必要があります。",
    cannotSignIn: "サインインできませんでした。",
    cannotRegister: "アカウントを作成できませんでした。",
  },
  newsletter: {
    overline: "ニュースレター",
    headline: "ドロップは公開前にアナウンスされます。",
    body:
      "スパムなし、マーケットプレイス的な雑音なし。希少な何かが公開されるとき、ひとつの映画的な配信を。",
    yourEmail: "あなたのEmail",
    placeholder: "you@example.com",
    subscribe: "登録",
    submitting: "...",
    success: "リストに追加されました。受信箱の近くで待っていてください。",
    fail: "登録に失敗しました。再度お試しください。",
  },
  counter: {
    overline: "インナーサークル",
    membersSuffix: "名のコレクターが鍵を持っています",
  },
  concierge: {
    label: "コンシェルジュ",
    open: "コンシェルジュと話す",
    title: "コンシェルジュ",
    subtitle: "保管庫について何でもお尋ねください。",
    placeholder: "メッセージを入力…",
    send: "送信",
    welcome: "Garage Drops のコンシェルジュです。ドロップ、メンバーシップ、アーカイブまで、保管庫をご案内します。何でも聞いてください。",
    typing: "返答を準備中…",
    error: "回線が一時的に切れました。少し時間をおいて再度お試しください。",
    close: "閉じる",
  },
  intro: {
    line1: "プライベートネットワークに接続中",
    line2: "保管庫を開いています",
    lineGlitch: "// シグナル // シグナル //",
    skip: "スキップ",
    label: "Garage Drops · 制限付きアクセス",
    check1: "セキュア接続",
    check2: "訪問者認証",
    check3: "アーカイブ解放",
    granted: "アクセス許可",
    welcome: "保管庫へようこそ",
  },
  signal: {
    overline: "プライベート・シグナル",
    headline: "希少な何かがリリースされる時、ただ一度の通信。",
    body: "マーケットプレイスの雑音もスパムもなし。ドロップは他のどこより先にここで告知されます。",
    placeholder: "your@private.email",
    submit: "シグナルに参加",
    submitting: "送信中…",
    successText: "通信を受信しました",
    successSub: "受信箱の近くで待っていてください。",
    error: "登録に失敗しました。再度お試しください。",
    explainerLabel: "登録すると",
    explainer1: "メールのみ — アカウントもパスワードも不要。",
    explainer2: "ドロップの24時間前に1通だけ通信。",
    explainer3: "スパムなし。ワンクリックで解除可能。",
  },
  offer: {
    overline: "プライベート・リクエスト",
    signedInOverline: "● ログイン中:",
    useOtherEmail: "別のメールを使う",
    useMyData: "アカウントを使う",
    headline: "ご興味がありますか? 痕跡をどうぞ。",
    body: "お名前と、知りたい情報(価格、状態、在庫)をお知らせください。担当者より個別かつ機密に連絡いたします。",
    firstName: "名",
    lastName: "姓",
    name: "氏名",
    email: "Email",
    country: "国",
    phone: "電話番号(任意)",
    amount: "オファー金額",
    message: "メッセージ",
    messagePlaceholder: "価格を知りたい · 内覧を希望 · ...について情報を希望",
    submit: "興味があります",
    submitting: "暗号化中…",
    privacyNote: "暗号化 · 24時間以内に個別返信",
    successText: "リクエストを受領しました",
    successSub: "担当者よりまもなくご連絡いたします。",
    error: "送信に失敗しました。再度お試しください。",
  },
  presentation: {
    featuredOverline: "現在のドロップ",
    liveNow: "ライブ中",
    countdownLabel: "終了まで",
    viewFullDrop: "ドロップを見る",
    apply: "保管庫に入る",
    objectOverline: "オブジェクト",
    galleryOverline: "ギャラリー",
    specsOverline: "仕様",
    storyOverline: "物語",
    closingLine: "タイマーが終わると、このオブジェクトは消えます。",
    lockedHeadline: "このドロップは封印されています。",
    lockedBody:
      "メンバーシップに申し込むと、写真・仕様・物語が解放されます。",
    archiveLinkOverline: "アーカイブ",
    archiveLinkBody: "プライベートコレクションに移ったドロップを見る →",
  },
  footer: {
    description:
      "希少な自動車と映画的なコレクター向けドロップのための、隠されたデジタル保管庫。",
    navigateOverline: "ナビゲート",
    legalOverline: "法的事項",
    legal: {
      privacy: "プライバシーポリシー",
      cookies: "Cookieポリシー",
      terms: "利用規約",
    },
    nav: {
      home: "ホーム",
      drops: "現在のドロップ",
      archive: "アーカイブ",
      register: "保管庫に入る",
      signIn: "サインイン",
    },
    rights: "© {year} Garage Drops",
    tagline: "保管庫は日没に開く",
    disclaimer:
      "私個人のプライベートコレクションの品です。私的販売。現状渡し、保証および返品はありません。",
  },
  privacy: {
    overline: "法的事項",
    title: "プライバシーポリシー",
    updated:
      "最終更新: 2026年2月 · EU GDPR (Reg. 2016/679) およびイタリア D.Lgs. 196/2003 に準拠。",
    s1Title: "1. データ管理者",
    s1Body:
      "Garage Drops(「プラットフォーム」)は、本サイトを通じて収集される個人データの管理者です。データに関するご質問は、",
    s2Title: "2. 収集するデータ",
    s2Intro: "以下のカテゴリのデータを処理します:",
    s2List: [
      "アカウントデータ — Email、ハッシュ化されたパスフレーズ、国。",
      "ニュースレター登録 — Email、国(任意)、タイムスタンプ。",
      "技術データ — IPアドレス、User Agent、基本ログ(最大90日間保持)。",
    ],
    s3Title: "3. 法的根拠と目的",
    s3Body:
      "(a) 契約上の必要性 — メンバーシップとドロップへのアクセスを提供するため; (b) 同意 — ニュースレター登録のため、いつでも撤回可能; (c) 正当な利益 — 不正防止とプラットフォームの整合性のため。",
    s4Title: "4. Cookieポリシー",
    s4Body:
      "Garage Drops は厳密に必要なCookie(httpOnly認証Cookie)のみを使用します。第三者によるトラッキング、広告、アナリティクスCookieは導入されていません。",
    s5Title: "5. データ保持期間",
    s5Body:
      "アカウントデータは、メンバーシップが有効である期間および削除リクエスト後24か月間、法的記録のために保持されます。ニュースレターデータは登録解除まで。技術ログは90日間。",
    s6Title: "6. データの共有",
    s6Body:
      "データを販売することはありません。プラットフォーム運営に必要なサブプロセッサーとのみ共有します: クラウドホスティング(EU内)、メール配信(Resend、EU/US with SCC)、オブジェクトストレージ(Emergent インフラ)。",
    s7Title: "7. ユーザーの権利 (GDPR第15-22条)",
    s7Intro: "次の権利があります:",
    s7List: [
      "個人データへのアクセスとコピーの取得。",
      "不正確なデータの訂正。",
      "削除(忘れられる権利)。",
      "処理の制限または異議申立て。",
      "データポータビリティ。",
      "いつでも同意を撤回(過去の処理の適法性に影響しない)。",
      "イタリアのデータ保護機関への苦情申し立て。",
    ],
    s7Outro: "これらの権利を行使するには、",
    s8Title: "8. セキュリティ",
    s8Body:
      "パスフレーズはbcryptでハッシュ化されて保存されます。通信はHTTPSで行われます。認証トークンはhttpOnly SecureなCookieに保管されます。管理ツールへのアクセスは認証と隠しルートで保護されています。",
    s9Title: "9. 利用規約",
    s9Body:
      "プラットフォームを利用することで、これらの利用規約に同意したことになります。メンバーシップは無料で提供され、不正使用の場合は当社の裁量で取り消すことができます。すべてのドロップ、写真、編集コンテンツは Garage Drops または記載されている職人、修復家、写真家の所有物のままです。",
    s10Title: "10. 本ポリシーの変更",
    s10Body:
      "本ポリシーは随時更新される場合があります。重大な変更については、メンバーへメールで通知します。",
  },
  upcoming: {
    overline: "プライベートコレクション",
    headline: "Collezioneカタログ。",
    subtitle:
      "完全なプライベートコレクション。公式に販売されるのは一度に一台のみ。残りはカタログに保管されます。メンバーは任意のモデルに関する情報を請求できます。",
    empty: "カタログは準備中です。このページをご注目ください。",
    locked: "ロック",
    filterAll: "すべて",
    filterAuto: "Auto",
    filterMoto: "Moto",
  },
  quickInquiry: {
    overline: "クイック問合せ",
    headline: "ご質問は？お気軽にどうぞ。",
    body: "登録不要。短いメッセージにプライベートで返信します。",
    name: "お名前",
    email: "メールアドレス",
    message: "メッセージ",
    send: "送信",
    sent: "送信しました。まもなく返信いたします。",
    error: "送信に失敗しました。再度お試しください。",
    memberHook: "完全なカタログをご覧になりたいですか?",
    memberCta: "メンバーになる — Collezioneへの完全アクセス",
  },
  welcome: {
    overline: "ようこそ",
    headline: "Garage Dropsとは。",
    body1:
      "Garage Dropsは、希少な自動車と希少なバイクを扱うプライベートコレクションです。レストア済みで厳選された車両を、私個人のコレクションと、慎重に選ばれた他のプライベートコレクションから出品しています。",
    body2:
      "各車両は専用のシネマティック・リリースで発表されます。公式に販売されるのは一度に一台のみで、残りはCollezioneの中で保管されます。",
    body3:
      "公開前に、各車両は点検と路上テストを実施します。完全なレストア記録が無い場合でも、私たちと提携工場が点検・テストを行い、適正な動作と将来のオーナーへの完全な透明性を保証します。",
    body4:
      "プライベートセール:すべての車両は私個人のコレクションまたは厳選されたプライベートコレクションからの出品で、現状渡し、保証および返品はありません。",
    languageLabel: "言語",
    privacyPrefix: "続行することで、以下に同意したものとみなします:",
    privacyLink: "プライバシーポリシー",
    continue: "Collezioneへ入る",
  },
  signalPrivileges: {
    overline: "メンバー特典",
    headline: "Collezioneで解放される特権。",
    body: "メンバーになるとCollezioneカタログ全体にアクセスでき、現在販売されていない車両についてもプライベートにお問い合わせいただけます。",
    items: [
      "完全なカタログへのアクセス",
      "販売されていない車両も含む、各車両のストーリー・写真・詳細",
      "あらゆる車両への個別の問い合わせ",
    ],
    footer: "公式に販売されるのは一度に一台のみ。残りはカタログで生き続けます。",
  },
};

export default ja;
